import { useParams } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import { ErrorBlock, LoadingBlock } from '@/components/feature/SectionState';
import useEvent from '@/hooks/useEvent';
import { placeholderRecap } from '@/lib/placeholders';
import EventHero from './components/EventHero';
import EventFacts from './components/EventFacts';
import EventInfo from './components/EventInfo';
import EventRegistration from './components/EventRegistration';
import EventGallery from './components/EventGallery';
import EventSignupPanel from './components/EventSignupPanel';

export default function EventDetail() {
  const { slug } = useParams();
  const { data: event, loading, error, reload } = useEvent(slug);

  const recap = event?.recap && event.recap.trim() ? event.recap : event ? placeholderRecap(event.name) : '';

  return (
    <div className="bg-background-50 text-foreground-950 min-h-screen">
      <Header />
      <main>
        {loading && <div className="px-4 md:px-8 pt-32 pb-20"><LoadingBlock label="Loading tournament" /></div>}
        {error && <div className="px-4 md:px-8 pt-32 pb-20"><ErrorBlock message={error} onRetry={reload} /></div>}

        {!loading && !error && event && (
          <>
            <EventHero event={event} />
            <EventFacts event={event} />

            <div className="px-4 md:px-8 py-14 md:py-20 grid grid-cols-1 lg:grid-cols-12 gap-10">
              <div className="lg:col-span-8">
                <EventInfo event={event} />

                <section className="mt-12">
                  <p className="font-label uppercase tracking-[0.25em] text-sm text-primary-500 font-bold">Recap</p>
                  <h2 className="font-heading font-extrabold uppercase text-3xl md:text-5xl leading-none mt-2">{event.name}</h2>
                  <p className="mt-5 text-foreground-700 leading-relaxed">{recap}</p>
                </section>

                <EventGallery images={event.gallery || []} />

                {event.partner && (
                  <section className="mt-12 bg-background-100 rounded-lg p-6 md:p-8 border border-background-200">
                    <h2 className="font-heading font-extrabold uppercase text-3xl">Partners</h2>
                    <div className="mt-4 flex items-center gap-4">
                      <span className="w-12 h-12 rounded-md bg-secondary-100 text-secondary-800 flex items-center justify-center text-2xl"><i className="ri-plant-line"></i></span>
                      <p className="font-heading font-bold uppercase text-xl">{event.partner}</p>
                    </div>
                  </section>
                )}
              </div>

              <aside className="lg:col-span-4">
                <div className="lg:sticky lg:top-28 flex flex-col gap-6">
                  <EventRegistration event={event} />
                  <EventSignupPanel event={event} />
                </div>
              </aside>
            </div>
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}